"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductValueControl = void 0;
const react_1 = __importStar(require("react"));
const bulk_edit_attributes_dialog_constants_1 = require("../bulk-edit-attributes-dialog.constants");
const bulk_edit_product_attributes_dialog_styles_1 = require("../bulk-edit-product-attributes-dialog.styles");
const values_1 = require("../../../../client/values");
const attributes_1 = require("../../../../constants/attributes");
const autocomplete_tags_1 = require("../../../../generic/autocomplete-tags");
const hooks_1 = require("../../../../../hooks");
const icons_1 = require("../../../../../icons");
const localization_1 = require("../../../../../localization");
const store_1 = require("../../../../../store");
const ProductValueControl = ({ isDisabled, productTreeNodeId, selectedAttributeId, selectedValues, onChange, operationType, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addError } = (0, hooks_1.useNotification)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const { data, isLoading, called, error, pagination: { hasNextPage, isLoadingMore, onNextPage, }, refetch, } = (0, values_1.useGetStrategyValueOptionList)({
        productTreeNodeId,
        catalogId: selectedCatalogId,
        attributeName: selectedAttributeId,
        options: { skip: !selectedAttributeId, fetchPolicy: 'network-only' },
    });
    (0, react_1.useEffect)(() => {
        if (error) {
            addError(t({ key: 'BULK_EDIT_VALUES_LOAD_ERROR' }));
        }
    }, [addError, error, t]);
    // useLazyQuery has not fired yet on the first render: treat that window as loading
    // so the dropdown shows a spinner instead of a premature "Not Applicable" option.
    const isInitializing = !called && !!selectedAttributeId;
    const options = (0, react_1.useMemo)(() => {
        if (!data)
            return [];
        const NOT_APPLICABLE = attributes_1.SpecialAttributeValue.NotApplicable;
        const valueOptions = data.map(({ node: { value } }) => ({
            label: value,
            value,
        }));
        if (operationType === bulk_edit_attributes_dialog_constants_1.BulkEditOperationTypes.Merge) {
            return valueOptions;
        }
        const hasNA = valueOptions.some((opt) => opt.value === NOT_APPLICABLE);
        const finalOptions = hasNA
            ? valueOptions
            : [
                {
                    label: t({ key: 'NOT_APPLICABLE' }),
                    value: NOT_APPLICABLE,
                    pinned: true,
                },
                ...valueOptions,
            ];
        return finalOptions;
    }, [data, t, operationType]);
    const DIVIDER_OPTION = {
        label: '__DIVIDER__',
        value: '__DIVIDER__',
        isDivider: true,
    };
    const groupedOptions = (0, react_1.useMemo)(() => {
        if (operationType === bulk_edit_attributes_dialog_constants_1.BulkEditOperationTypes.Merge)
            return options;
        const NOT_APPLICABLE = attributes_1.SpecialAttributeValue.NotApplicable;
        const pinned = options.filter((opt) => opt.value === NOT_APPLICABLE);
        const regular = options.filter((opt) => opt.value !== NOT_APPLICABLE);
        if (!pinned.length)
            return regular;
        if (!regular.length)
            return pinned;
        return [...pinned, DIVIDER_OPTION, ...regular];
    }, [options, operationType]);
    const handleChange = (0, react_1.useCallback)((values) => {
        const NA = attributes_1.SpecialAttributeValue.NotApplicable;
        let newValues = [...values];
        if (newValues.includes(NA)) {
            if (newValues[newValues.length - 1] === NA) {
                newValues = [NA]; // NA selected last
            }
            else {
                newValues = newValues.filter((v) => v !== NA); // remove NA
            }
        }
        onChange(newValues);
    }, [onChange]);
    const getChipProps = () => ({ accent: true, icon: react_1.default.createElement(icons_1.AISparkleIcon, null) });
    const renderOptionLabel = (0, react_1.useCallback)((option) => {
        if (option.isDivider) {
            return (react_1.default.createElement("div", { style: { borderBottom: '1px solid #e0e0e0', margin: '4px 0' } }));
        }
        return (react_1.default.createElement(bulk_edit_product_attributes_dialog_styles_1.StyledOptionWrapper, null, option.label, option.value !== attributes_1.SpecialAttributeValue.NotApplicable && (react_1.default.createElement(icons_1.AISparkleIcon, null))));
    }, []);
    const renderTagLabel = (0, react_1.useCallback)((value) => {
        const NA = attributes_1.SpecialAttributeValue.NotApplicable;
        return value === NA
            ? t({ key: 'NOT_APPLICABLE_SHORT' })
            : value;
    }, [t]);
    return (react_1.default.createElement(autocomplete_tags_1.AutocompleteTags, { isDisabled: isDisabled, onChange: handleChange, options: groupedOptions, selected: selectedValues, placeholder: t({ key: 'BULK_EDIT_VALUES_DIALOG_PLACEHOLDER' }), hasNextPage: hasNextPage, isLoading: isLoading || isInitializing, moreItemsLoading: isLoadingMore, noOptionsText: t({ key: 'NO_DATA_AVAILABLE' }), onLoadMore: onNextPage, onSearch: refetch, getChipProps: getChipProps, renderOptionLabel: renderOptionLabel, renderTagLabel: renderTagLabel, getOptionDisabled: (option) => option.isDivider === true }));
};
exports.ProductValueControl = ProductValueControl;
exports.default = exports.ProductValueControl;
